"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiFormHelperText = function MuiFormHelperText() {
  return {
    /* Styles applied to the root element. */
    root: {
      alignItems: 'center',
      display: 'flex',
      fontWeight: 400,
      '& > svg': {
        fontSize: '1rem',
        marginRight: 4
      }
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 24,
      marginRight: 24
    }
  };
};

var _default = MuiFormHelperText;
exports["default"] = _default;